function leftNav() {
  var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
  var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  var d = $(document).scrollTop();

  $(".dropdown-menu").each(function(){
    p = $(this).offset();

    //horizontal
    if ((p.left + $(this).width()) > $(window).innerWidth()) {
      $(this).addClass('menu-left');
    }
  });
}

var doubleTapMenus = function(){
  //double tapping on iPad menus (it assumes Modernizr is being used)
  if(!$('html').hasClass('no-touch')){
    var lastTouch = '';
    $('.nav-primary li.dropdown > a').on('click', function(e){
      if(!$(this).hasClass('touched') || lastTouch != $(this).attr('href')){
        e.preventDefault();
      }
      $(this).addClass('touched');
      lastTouch = $(this).attr('href');
    });
  }
};

$(document).ready(function() {
	doubleTapMenus();

  $('.nav-toggle').on('click', function(){
    if ($('body').hasClass('nav-open')) {
      $('body').removeClass('nav-open');
    } else {
      $('body').addClass('nav-open');
    }
  });

  $('.site-overlay').on('click', function(){
    $('body').removeClass('nav-open');
  });

  $('.nav-arrow').on('click', function(){
    $this = $(this);
    $parent = $this.parent('span');

    $parent.toggleClass('dropdown-menu-open');

    if (!$parent.hasClass('dropdown-menu-open')) {
      $parent.next().stop().slideUp();
    } else {
      $parent.next().stop().slideDown();
    }
  });

  $('.nav-primary a').on('focus', function() {
    $(this).parents('li').addClass('focussed');
  }).on('blur', function() {
    $(this).parents('li').removeClass('focussed');
  });

  leftNav();
});

$(window).on('resize', function() {
  $('.dropdown-menu').removeClass('menu-left');
  leftNav();
});

$(window).scroll(function() {
  var $scroll = $(window).scrollTop();
  var $offset = $(".header-primary").height();

  if ($scroll >= $offset) {
    $(".header-primary").addClass("header-small");
  } else {
    $(".header-primary").removeClass("header-small");
  }
});

function changeGoogleStyles() {
    if(($goog = $('.goog-te-menu-frame').contents().find('body')).length) {
        var stylesHtml = '<style>'+
            '.goog-te-menu2 {'+
                'max-width:100% !important;'+
                'overflow:scroll !important;'+
                'box-sizing:border-box !important;'+
                'height:auto !important;'+
                '-webkit-overflow-scrolling:touch;'+
            '}'+
            '@media only screen and (max-width : 720px) {'+
              '.goog-te-menu2 {'+
                  'width:100%!important;'+
                  'box-sizing:initial !important;'+
                  'display: block;'+
                  'height:auto !important;'+
                  'left:0 !important;'+
                  'border: none !important;'+
              '}'+
            '}'+
        '</style>';
        $goog.prepend(stylesHtml);
    } else {
        setTimeout(changeGoogleStyles, 50);
    }
}
changeGoogleStyles();

$(window).on('resize', function(){
  shiftTranslateBox();
});

shiftTranslateBox();

function shiftTranslateBox() {
  if($(window).width() >= 767){
    $('#google_translate_element').detach().prependTo('.header-right .donate-phone');
  } else {
    $('#google_translate_element').detach().insertAfter('#header');
  }
}



$('.emergency-help h2').on('click', function(){
  if ($(window).width() < 768) {
    $(this).toggleClass('active');
  }
});
